import 'react-toastify/dist/ReactToastify.min.css'
import 'keen-slider/keen-slider.min.css'
import '../global.css'

import { app, createStore, getHomeUrl } from '@obvio/app'
import { Popup } from '@obvio/template'
import Script from 'next/script'

import { PopupContent } from '@/components/PopupContent'
import { YTContext } from '@/components/YTContext'
import { SITE_DESCRIPTION, SITE_NAME, SITE_OG_IMAGE } from '@/constants/seo'

export const globalStore = createStore(
  {
    NEWSLETTER: (_, newState = true) => ({
      newsletter: newState,
    }),
  },
  { newsletter: false },
)

export default app({
  globalStoreHook: globalStore,
  contextPaths: {
    /* TODO: change to ecommerce contextPath when ready. */
    ecommerce: '/sklep',
    'ecommerce.product': '/sklep/produkt',
    'ecommerce.category': '/sklep/kategoria',
    'ecommerce.search': '/sklep',
    'ecommerce.checkout': '/sklep/zakupy',
    'ecommerce.userPanel': '/sklep/panel',
    'ecommerce.userPanel.wishlist': '/sklep/panel/ulubione',
    'ecommerce.userPanel.settings': '/sklep/panel/ustawienia',
    'ecommerce.userPanel.addresses': '/sklep/panel/adresy',
    signIn: '/logowanie',
    signUp: '/rejestracja',
    privacyPolicy: '/polityka-prywatnosci',
    tos: '/regulamin',
    forgotPassword: '/zresetuj-haslo',
  },
  seoData: {
    title: SITE_NAME,
    canonical: getHomeUrl(),
    description: SITE_DESCRIPTION,
    openGraph: {
      type: 'website',
      title: SITE_NAME,
      description: SITE_DESCRIPTION,
      images: [SITE_OG_IMAGE],
    },
  },
  enhance: (Component) => (props) =>
    (
      <YTContext>
        <Script
          src="//code.jquery.com/jquery-3.6.0.slim.min.js"
          strategy="afterInteractive"
          async
        />
        <Script
          src="//open.upperbooking.com/poziom511jurawellnesshotelspa/Booking.js?locale=pl"
          strategy="afterInteractive"
          async
        />
        <Component {...props} />
        <Popup>{(data) => <PopupContent {...data} />}</Popup>
      </YTContext>
    ),
})
